<div class="container">
  <div class="row">
    <div class="col-md-6 col-lg-4 col-xl-3 mx-auto mt-5 mb-4">
      <img
        class="img-fluid"
        src="./assets/img/getapollo.io-astronaut.svg"
        alt=""
      />
    </div>
  </div>

  <div class="row mb-3 text-center">
    <div class="col">
      <h1 class="h2">{{ 'Page not found' | translate }}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col text-center">
      <p class="h3 mb-5 font-weight-light">
        {{ 'not-found.text' | translate }}
      </p>
      <ng-container *ngIf="!parentId">
        <button class="btn btn-outline-primary" [routerLink]="['/login']">
          {{ 'not-found.btn.login' | translate }}
        </button>
      </ng-container>

      <ng-container *ngIf="parentId">
        <button class="btn btn-outline-primary" [routerLink]="['/', parentId]">
          {{ 'not-found.btn.dashboard' | translate }}
        </button>
      </ng-container>
    </div>
  </div>
</div>
